import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const EarlyAccess = () => {
  return (
      <section
          id="contact"
          className="relative overflow-hidden border-t border-white/10 bg-[#05070b] text-white"
      >
        {/* Subtle background atmosphere */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute left-1/2 top-1/2 h-[420px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-cyan-400/[0.018] blur-[150px]" />
        </div>

        <div className="relative z-10 mx-auto max-w-[1100px] px-8 py-24 text-center sm:py-28">

          {/* Label */}
          <div className="mb-7 flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-cyan-400/60" />

            <span className="text-[10px] font-medium tracking-[0.28em] text-cyan-300/70">
                        GET IN TOUCH
                    </span>

            <span className="h-px w-8 bg-cyan-400/60" />
          </div>

          {/* Heading */}
          <h2 className="mx-auto max-w-[820px] text-[40px] font-semibold leading-[1.03] tracking-[-0.045em] sm:text-[52px] lg:text-[64px]">
    <span className="text-neutral-500">
        Interested in
    </span>
            <br />
            what we're building?
          </h2>

          {/* Description */}
          <p className="mx-auto mt-7 max-w-[760px] text-[15px] leading-7 text-slate-400 sm:text-[17px]">
            We're looking for device makers, technology partners and
            collaborators interested in bringing cognitive intelligence
            into the next generation of wearable products.
          </p>

          {/* Email */}
          <div className="mt-11">
            <div className="text-[10px] font-medium uppercase tracking-[0.28em] text-slate-500">
              CONTACT
            </div>

            <a
                href="mailto:contact@frocort.com"
                className="group mt-4 inline-flex items-center gap-3 text-[24px] font-medium tracking-[-0.02em] text-white transition-colors hover:text-cyan-300 sm:text-[30px]"
            >
              contact@frocort.com

              <ArrowUpRight
                  size={21}
                  className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
              />
            </a>
          </div>

        </div>
      </section>
  );
};

export default EarlyAccess;